import { ACTION_TYPES } from '../../utils/Constants';
import { myLog } from '../../utils/Utility';

/**
 * called when changing network provider
 * @param {*} isOnline
 */
export const networkChanged = (isOnline) => {
    myLog('networkChanged', isOnline);
    return (dispath) => {
        dispath(customeAction(ACTION_TYPES.NETWORK_CHNAGE, { isOnline }));
    };
};

/**
 * called when there is networkProblem
 * @param {*} isNetworkProblem
 */
export const networkProblem = (isNetworkProblem) => {
    myLog('networkProblem', isNetworkProblem);
    return (dispath) => {
        dispath(customeAction(ACTION_TYPES.NETWORK_PROBLEM, { isNetworkProblem }));
    };
};
export const deactivateUserScreen = (deactivateUser) => {
    myLog('deactivateUser', deactivateUser);
    return (dispath) => {
        dispath(customeAction(ACTION_TYPES.DEACTIVATE_USER_SCREEN, { deactivateUser }));
    };
};
export const socketServerDownProblem = (isSocketDownProblem) => {
    myLog('socketDownProblem', isSocketDownProblem);
    return (dispath) => {
        dispath(
            customeAction(ACTION_TYPES.SOCKET_SERVER_DOWN_PROBLEM, {
                isSocketDownProblem,
            })
        );
    };
};

/**
 * custom action for dispatch
 * @param {*} action
 * @param {*} data
 */
export const customeAction = (action, data) => {
    return {
        type: action,
        payload: data,
    };
};
